import React from 'react'

const EmptyDayItem = () => {
    return (
        <div className="common-calendar__day common-calendar__day_empty"></div>
    )
}

export default EmptyDayItem